import styled from 'styled-components'
import { device, fonts } from '../../../styles/GlobalVariables'

const slotGap = 4
export const MinuteLyTopVideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  ${device.regular} {
    flex-direction: row;
    gap: ${slotGap}%;
  }
`
const slotPercent = 64
export const MinuteLyTopVideoSlotWrapper = styled.div`
  flex: 0 0 ${slotPercent}%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`
export const MinuteLyTopVideoSlot = styled.div`
  aspect-ratio: 16 / 9;
  background-color: #000;
`
export const MinuteLyTopVideoTitle = styled.div`
  font-family: ${fonts.narkis};
  font-weight: 700;
  font-size: 28px;
  line-height: 1;

  ${device.regular} {
    font-size: 36px;
  }
`

export const MinuteLyTopVideoTitleWrapper = styled.div`
  position: relative;
`
export const MinuteLyTopPosts = styled.div`
  flex: 0 0 calc(${100 - slotPercent}% - ${slotGap}%);
  display: flex;
  flex-direction: column;
  gap: 19px;

  ${device.regular} {
    gap: 20px;
  }
`
const postGap = 20
export const MinuteLyTopPostContainer = styled.div`
  a {
    width: 100%;
    text-decoration: none;
    color: black;
    display: flex;
    flex-direction: row;
    gap: ${postGap}px;
  }
`

const thumbPrecent = 47
const thumbPrecentMob = Math.round((151 * 100) / 335)
export const MinuteLyTopPostThumb = styled.div`
  flex: 0 0 ${thumbPrecentMob}%;
  display: flex;
  aspect-ratio: 151 / 106;
  align-items: center;
  max-width: 210px;

  img {
    width: 100%;

    &.desktop {
      display: none;
    }

    &.mobile {
      display: block;
    }
  }

  ${device.regular} {
    flex: 0 0 ${thumbPrecent}%;
    aspect-ratio: 16 / 9;

    img {
      width: 100%;

      &.desktop {
        display: block;
      }

      &.mobile {
        display: none;
      }
    }
  }
`
export const MinuteLyTopPostTextWrap = styled.div`
  flex: 0 0 calc(${100 - thumbPrecentMob}% - ${postGap}px);
  font-family: ${fonts.narkis};
  gap: 4px;
  padding-left: 5px;
  max-height: 110px;
  overflow: hidden;

  ${device.regular} {
    flex: 0 0 calc(${100 - thumbPrecent}% - ${postGap}px);
  }
`
export const MinuteLyTopPostTopTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  padding: 2px 6px;
  background: #fff500;
  display: inline-flex;
  margin-bottom: 4px;
  line-height: 1.2;

  ${device.regular} {
    font-size: 16px;
  }
`
export const MinuteLyTopPostTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  text-align: right;
  vertical-align: middle;
  padding-left: 5px;
  line-height: 1.2;

  ${device.regular} {
    font-size: 20px;
  }
`
